/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { SnackbarProvider } from 'notistack';
import React from 'react';

import { NOTISTACK_MAX_STACK } from '../../constants/settings';
import { Notifier } from '../../containers/Notifier/Notifier';

export function HUSnackbarProvider({ children }: { children: React.ReactElement<any> }) {
  return (
    <SnackbarProvider
      domRoot={document.getElementById('react-notification') || undefined}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      maxSnack={NOTISTACK_MAX_STACK}
    >
      <>
        {children}
        <Notifier />
      </>
    </SnackbarProvider>
  );
}
